export default "__VITE_ASSET__CHNU$4fi__"